export default {"src":"/login-app/[GIT_HASH]/_next/static/media/github_pr_open.284a07bb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};